

enum WEIGHT_UNIT_ENUM {
    KG = 'kg'

}

export default WEIGHT_UNIT_ENUM;

